import React, { useState } from 'react';
import {
  FDBox, FDHorizontalTabs, FDStack, FDTabPanel,
} from '@facet-wealth/design';
import useLink from 'Hooks/useLink';
import { withHousehold } from 'Context/HouseholdContext';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import fr from 'facet-rest';
import { IncomeDetailsTableContainer } from 'Components/ComponentLibrary/Organisms/Income';
import IncomeTaxSectionPicker from '../ResourceSections/IncomeTax/IncomeTaxSectionPicker';

const TAB_OPTIONS = [
  {
    label: 'Income Details',
    value: 'income-details-table',
  },
  {
    label: 'Income Tax',
    value: 'income-tax-section',
  },
];


const IncomeDetailsRedesign = () => {
  const { householdResource } = useSimpleHousehold();
  const [tab, setTab] = useState(TAB_OPTIONS[0].value);
  const { collection: clientCollection } = useLink(householdResource.relationship(fr.relationships.clients.name).link('related'));

  const primaryClientResource = clientCollection?.resources().list().find(c => c.attr('isPrimary') === 'true');

  return (
    <FDStack
      direction="column"
      spacing={2}
    >
      <FDHorizontalTabs
        onChange={(event, v) => { setTab(v); }}
        value={tab}
        options={TAB_OPTIONS}
      />
      <FDBox>
        <FDTabPanel
          id={TAB_OPTIONS[0].value}
          value={tab}
        >
          <IncomeDetailsTableContainer />
        </FDTabPanel>
        <FDTabPanel
          id={TAB_OPTIONS[1].value}
          value={tab}
        >
          {primaryClientResource ? <IncomeTaxSectionPicker clientResource={primaryClientResource} /> : null}
        </FDTabPanel>
      </FDBox>
    </FDStack>
  );
};

IncomeDetailsRedesign.propTypes = {
};

export default withHousehold(IncomeDetailsRedesign);
